/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParentFields } from './parentFields';


/**
 * Field info
 */
export interface MetaField { 
    /**
     * Is required field
     */
    isRequired: boolean;
    /**
     * Is readonly field
     */
    isReadonly: boolean;
    /**
     * Is calculated field
     */
    isCalculated: boolean;
    /**
     * Is virtual field
     */
    isVirtual: boolean;
    /**
     * reg expression
     */
    regExp?: string | null;
    /**
     * reg expression message
     */
    regExpMsg?: string | null;
    /**
     * Default field value
     */
    defaultValue?: string | null;
    /**
     * Field type
     */
    type: string;
    /**
     * Field tag
     */
    readonly tag?: string | null;
    /**
     * Field name on form for client
     */
    formCaptionClient?: string | null;
    /**
     * Field name on table for operator
     */
    tableCaptionOperator?: string | null;
    /**
     * Field name on table for client
     */
    tableCaptionClient?: string | null;
    /**
     * Meta document id, if field type is reference
     */
    childMetaDocumentId?: number;
    /**
     * Element id
     */
    id: number;
    /**
     * Position for element
     */
    position: number;
    /**
     * Pseudo script indicating which control should be initialized in this tab
     */
    formHint_Operator?: string | null;
    /**
     * Element name on form
     */
    formCaption?: string | null;
    /**
     * Field name
     */
    fieldName?: string | null;
    /**
     * Is visible for operator in table
     */
    isVisibleTableOperator: boolean;
    /**
     * Is visible for operator on form
     */
    isVisibleOperator: boolean;
    /**
     * Is visible for client in table
     */
    isVisibleTableClient: boolean;
    /**
     * Is visible for client on form
     */
    isVisibleClient: boolean;
    fieldsRules?: ParentFields;
}

